import React, { useEffect, useState } from "react";
import Dashboard from "../../components/Dashboard";
import Navbar from "../../components/Navbar";
import { useUser } from "../../context/user-context";
import { FaUsers } from "react-icons/fa";

import { GoGift } from "react-icons/go";
import Assets from "./Assets";
import { HiMiniTrophy } from "react-icons/hi2";
import CoinWallet from "./CoinWallet";
import NairaWallet from "./NairaWallet";
import useUserAsset from "../../hooks/useUserAssets";
import { formatAmount } from "../../utils/formatTime";
import Referral from "../settings/Referral";
import useAuthAxios from "../../utils/baseAxios";
import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { API } from "../../constants/api";
import { errorMessage } from "../../utils/errorMessage";

const Wallet = () => {
  const { isOpen } = useUser();
  const { totalBalance, loading } = useUserAsset();
  const [screen, setScreen] = useState<boolean>(false);
  const [openCoin, setOpenCoin] = useState<boolean>(false);
  const [selectedCoinObj, setSelectedCoinObj] = useState<any>(null);
  const [openRefer, setOpenRefer] = useState<boolean>(false);
  const axiosInstance = useAuthAxios();

  // The promo slider lives on the dashboard only. It used to render here too, which showed
  // the same admin campaign twice in one session; mobile made the same call for its
  // gift-card tab. The dashboard's version is the one that carries the notification CTA.
  const handleTouchStart = (e: React.TouchEvent) => {
    const touch = e.touches[0];
    setTouchStart({ x: touch.clientX, y: touch.clientY });
  };

  const handleTouchEnd = (e: React.TouchEvent) => {
    const touch = e.changedTouches[0];
    const deltaX = touch.clientX - touchStart.x;
    const deltaY = touch.clientY - touchStart.y;

    // Detect a swipe (left, right, up, or down)
    if (
      Math.abs(deltaX) > SWIPE_THRESHOLD ||
      Math.abs(deltaY) > SWIPE_THRESHOLD
    ) {
      setScreen((prev) => !prev);
    }
  };

  const [touchStart, setTouchStart] = useState<{ x: number; y: number }>({
    x: 0,
    y: 0,
  });
  const SWIPE_THRESHOLD = 50; // Adjust this threshold to your liking
  // console.log(userDetails);

  const getPoint = async () => {
    const response = await axiosInstance.get(API.getPointsBalance);
    return response.data;
  };
  const { data: point, error: error1 } = useQuery({
    queryKey: ["get-point"],
    queryFn: getPoint,
    retry: 1,
  });
  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1]);
  const pointBalance = point?.data?.totalPoints;
  return (
    <div className="lgss:flex font-manrope  lgss:flex-row h-screen lgss:h-screen bg-[#E7EBEE]   dark:bg-[#13181B]">
      <Dashboard />
      <div
        className={
          isOpen
            ? "w-full h-full pt-0  font-manrope overflow-hidden lgss:px-0 flex flex-col justify-start item-start lgss:w-[80%]"
            : "w-full h-full pt-0  font-manrope overflow-auto lgss:px-0 flex flex-col justify-start item-start lgss:w-[80%]"
        }
      >
        <Navbar />
        <div className="w-full mt-10">
          {openCoin ? (
            selectedCoinObj?.isNaira ? (
              <NairaWallet
                setOpenCoin={setOpenCoin}
                selectedCoinObj={selectedCoinObj}
                setSelectedCoinObj={setSelectedCoinObj}
              />
            ) : (
              <CoinWallet
                setOpenCoin={setOpenCoin}
                selectedCoinObj={selectedCoinObj}
                setSelectedCoinObj={setSelectedCoinObj}
              />
            )
          ) : (
            <div className="w-full lgss:px-8 xl:px-12 xxl:px-20  xxxl:px-36 md:px-12 mds:px-8 px-4 overflow-auto pb-20 lgss:pb-8 flex flex-col lgss:flex-row gap-6">
              <div className="w-full lgss:w-1/2 mt-6 ">
                <div
                  onTouchStart={handleTouchStart}
                  onTouchEnd={handleTouchEnd}
                  className="w-full py-6 px-4 rounded-xl bg-bulkBg  bg-[#042741]"
                >
                  <div className="flex justify-end items-center">
                    <button className="text-white text-[13px] font-bold bg-gradient-to-r py-[2px] capitalize from-[#FF5F6D] to-[#FFC371] rounded-lg px-2 flex justify-center items-center gap-2">
                      rewards <GoGift />
                    </button>
                  </div>
                  <div className="flex flex-col justify-center mt-2 items-center">
                    <h4 className="text-gray-100 text-[13px] font-semibold uppercase">
                      {screen ? "Earnings" : "Holdings"}
                    </h4>
                    <h4 className="text-gray-100 font-sora text-[23px] mt-6 font-semibold uppercase">
                      {screen
                        ? `₦${formatAmount(pointBalance * 10)}`
                        : `$${loading ? "----" : formatAmount(totalBalance)}`}
                    </h4>
                    {screen ? (
                      <div className="flex text-[11px] gap-1 mt-8 items-center">
                        <HiMiniTrophy className="text-[12px] text-[#17E833]" />

                        <h4 className="text-[#17E833]">
                          {formatAmount(pointBalance)} points
                        </h4>
                      </div>
                    ) : (
                      <div className="flex text-[11px] gap-1 mt-8 items-center">
                        {/* <RiArrowUpSFill className="text-[12px] text-[#17E833]" />

                        <h4 className="text-[#17E833]">
                          23%<span className="text-gray-100"> (24h)</span>
                        </h4> */}
                      </div>
                    )}
                    <div className="flex text-[11px] gap-1 mt-8 items-center">
                      <div
                        onClick={() => setScreen(false)}
                        className={
                          !screen
                            ? "w-[9px] h-[9px] rounded-full bg-secondary_button"
                            : "w-[9px] h-[9px] rounded-full bg-gray-200"
                        }
                      />
                      <div
                        onClick={() => setScreen(true)}
                        className={
                          screen
                            ? "w-[9px] h-[9px] rounded-full bg-secondary_button"
                            : "w-[9px] h-[9px] rounded-full bg-gray-200"
                        }
                      />
                    </div>
                  </div>
                </div>
                <Assets
                  setOpenCoin={setOpenCoin}
                  setSelectedCoinObj={setSelectedCoinObj}
                />
              </div>
              <div className="w-full lgss:w-1/2 pb-20 lgss:pb-0 mt-6 ">
                {/* <QuickActions /> */}
                <div
                  onClick={() => setOpenRefer(true)}
                  className="flex justify-start bg-white dark:bg-[#1C2227] w-full px-6 py-4 mt-6 rounded-xl items-center gap-4"
                >
                  <div className="flex justify-center items-center  text-[24px] text-secondary_button  rounded-full">
                    <FaUsers />
                  </div>
                  <div>
                    <h4 className="text-secondary_button font-bold text-[14px] ">
                      Refer & Earn
                    </h4>
                    <h4 className="text-gray-500 dark:text-gray-300 mt-1 font-medium text-[12px] ">
                      Invite friends to download the DeeX application and get
                      10% off their first transaction.
                    </h4>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {openRefer && <Referral setOpenRefer={setOpenRefer} />}
    </div>
  );
};

export default Wallet;
